import Image from "next/future/image";

const ImageContainer = ({ backgroundImage, overlayImage, altText }) => (
  <div className={`images-div`}>
    <div className="bg">
      <Image
        src={backgroundImage}
        alt={altText || "background image"}
        width={688}
        height={489}
        loading="lazy"
        priority={false}
      />
      {overlayImage && (
        <div className="work">
          <Image
            src={overlayImage}
            alt={altText || "overlay image"}
            width={688}
            height={489}
            loading="lazy"
            priority={false}
          />
        </div>
      )}
    </div>
  </div>
);

export default ImageContainer;
